// extracted by mini-css-extract-plugin
module.exports = {"searchSponsoredProductsContainer":"Si","product":"Ti","products":"Ui","tooltipWrapper":"Vi","tooltip":"Wi","title":"Xi","secondRow":"Yi","firstRow":"Zi"};